import { refreshAccessToken } from '../utils/tokens';
import instance from './scorpiusInstance';
import {
  REFRESH_USER_TOKEN_START,
  REFRESH_USER_TOKEN_SUCCESS,
  REFRESH_USER_TOKEN_ERROR,
} from './types';

export const refreshUserTokenStart = () => ({
  type: REFRESH_USER_TOKEN_START,
});

export const refreshUserTokenSuccess = token => ({
  type: REFRESH_USER_TOKEN_SUCCESS,
  token,
});

export const refreshUserTokenError = error => ({
  type: REFRESH_USER_TOKEN_ERROR,
  error,
});

/**
 * Refreshes the access token, announcing each stage as a Redux action.
 *
 * Signals failure by throwing the error action it just dispatched, which is
 * this thunk's long-standing contract — `createAccessTokenProvider` re-wraps
 * the thrown action to give its callers something with a stack.
 */
export const refreshUserToken = refresh_token => async dispatch => {
  const result = await refreshAccessToken({
    refreshToken: refresh_token,
    transport: (path, body) => instance.post(`/${path}`, body),
    onRequestStart: () => dispatch(refreshUserTokenStart()),
  });

  switch (result.status) {
    case 'refreshed':
      // Keep the instance's default header in step, so requests built from the
      // defaults rather than per-call config carry the new token.
      instance.defaults.headers.Authorization = `Bearer ${result.token}`;
      return dispatch(refreshUserTokenSuccess(result.token));

    case 'no-refresh-token':
      throw dispatch(
        refreshUserTokenError(
          new Error('No usable refresh token to refresh with'),
        ),
      );

    case 'no-token-in-response':
      throw dispatch(
        refreshUserTokenError(
          new Error('Refresh response carried no access token'),
        ),
      );

    default:
      throw dispatch(refreshUserTokenError(result.failure));
  }
};

export default refreshUserToken;
